import React, { useEffect, useState } from "react";
import Button from "../../../forms/Button";
import { add } from "lodash";
import { useSelector } from "react-redux";
import useFetch from "../../../../hooks/useFetch";
import { profileDetails } from "../../../../services/ProfileService";

const CurrentAddress = ({ address }) => {
  const typeHexColorMap = {
    Home: "#ef427c",
    Office: "#06D6A0",
    Relatives: "#fb923c",
    Others: "#4f46e5",
  };
  // console.log(address);
  // const addressdata = {
  //   name: "Michael Thomas",
  //   addressLine1: "1259 Greenfield Drive, Apt 304, San Mateo",
  //   addressLine2: "CA 94403, United States",
  //   phone: "1800 130 5577",
  //   email: "michael.t@memorydoodle.com",
  //   addressType: "Home",
  // };

  const defaultAddressFromRedux = useSelector(
    (state) => state.profile.defaultAddress
  );
  const [addressdata, setAddressdata] = useState(null);

  const { data: fetchedAddress, refetch } = useFetch({
    dependencies: ["defaultAddress"],
    fetchFunction: async () => {
      const res = await profileDetails({ isDefaultAddress: true });
      if (res?.status === 200) {
        return res?.data?.defaultAddress || null;
      }
      return null;
    },
  });

  // On initial mount or redux change, prefer redux data if available
  useEffect(() => {
    if (defaultAddressFromRedux?._id) {
      setAddressdata(defaultAddressFromRedux);
    } else {
      setAddressdata(fetchedAddress);
    }
  }, [defaultAddressFromRedux, fetchedAddress]);

  if (!addressdata) return null;

  // console.log(addressdata);
  const typeColor = typeHexColorMap[address?.addressType] || "#4f46e5";
  return (
    <>
      <div
        className="relative overflow-hidden bg-white py-4 px-4 shadow shadow-md-pink/20 rounded-lg z-0"
        style={{
          "--typeColor":
            typeHexColorMap[
              addressdata?.label ? addressdata?.label : addressdata?.addressType
            ],
        }}
      >
        <div className="mb-4 pb-4 border-b border-md-pink-light-1 flex items-center justify-between gap-4">
          <div className="text-lg 2xl:text-xl text-md-dark font-semibold">
            Default Address
          </div>
          <div className="ml-auto flex-shrink-0 flex items-center gap-1">
            <Button
              buttonHasLink={true}
              buttonLink={"/address"}
              buttonLabel={"View All"}
              buttonClasses={
                "!h-auto !rounded !px-2 !py-1 !text-md-pink !bg-transparent hover:!bg-md-pink/10 !gap-1"
              }
              buttonLabelClasses={"!font-semibold !text-md-pink !text-sm"}
            />
          </div>
        </div>
        <div
          className="relative overflow-hidden py-4 px-4 border border-md-pink-light-1 bg-white rounded-lg hover:shadow-md hover:shadow-md-pink/20 transition-all duration-300 hover:bg-md-pink-light-2 z-0"
          style={{
            "--typeColor":
              typeHexColorMap[
                addressdata?.label
                  ? addressdata?.label
                  : addressdata?.addressType
              ],
          }}
        >
          <div
            className="absolute bottom-0 left-0 h-10 w-full -z-10 translate-y-1/2 rounded-[50%] blur-xl opacity-15"
            style={{ backgroundColor: "var(--typeColor)" }}
          />
          <div className="relative z-10 flex items-start gap-6 flex-col 3xl:flex-row">
            <div
              className="relative z-0 flex-shrink-0 text-2xl 2xl:text-3xl w-12 2xl:w-16 aspect-square flex items-center justify-center rounded-lg"
              style={{
                boxShadow: "0 4px 10px -6px var(--typeColor)",
                color: "var(--typeColor)",
              }}
            >
              <div
                className="absolute inset-0 rounded-lg opacity-10 -z-[2]"
                style={{ backgroundColor: "var(--typeColor)" }}
              />
              <div
                className="absolute inset-0 rounded-lg border opacity-10 -z-[1]"
                style={{ borderColor: "var(--typeColor)" }}
              />
              <i className="fa-light fa-fw fa-house-building"></i>
            </div>
            <div className="space-y-1 flex-grow flex-shrink">
              <div className="flex items-start justify-between gap-4">
                <div className="text-base text-md-dark font-semibold">
                  {addressdata?.name}
                </div>
                <div
                  className="absolute top-0 right-0 3xl:top-auto 3xl:right-auto 3xl:relative flex items-center justify-center text-xs font-semibold pb-0.5 h-6 px-2 rounded"
                  style={{ color: "var(--typeColor)" }}
                >
                  <div
                    className="absolute inset-0 rounded opacity-10"
                    style={{ backgroundColor: "var(--typeColor)" }}
                  />
                  <div
                    className="absolute inset-0 rounded border opacity-10"
                    style={{ borderColor: "var(--typeColor)" }}
                  />
                  {addressdata?.label
                    ? addressdata?.label
                    : addressdata?.addressType}
                </div>
              </div>
              <div className="text-xs 2xl:text-sm text-slate-500 tracking-wide flex items-start gap-3">
                <i
                  className="fa-regular flex-shrink-0 fa-fw fa-buildings pt-1"
                  style={{ color: "var(--typeColor)" }}
                ></i>
                <span>
                  {addressdata?.address1
                    ? addressdata?.address1
                    : addressdata?.addressLine1}
                  <br />
                  {addressdata?.address2
                    ? addressdata?.address2
                    : addressdata?.addressLine2}
                </span>
              </div>
              <div className="text-xs 2xl:text-sm text-slate-500 tracking-wide flex items-start gap-3">
                <i
                  className="fa-regular flex-shrink-0 fa-fw fa-phone pt-1"
                  style={{ color: "var(--typeColor)" }}
                ></i>
                <span>{addressdata?.phone}</span>
              </div>
              <div className="text-xs 2xl:text-sm text-slate-500 tracking-wide flex items-start gap-3">
                <i
                  className="fa-regular flex-shrink-0 fa-fw fa-envelope pt-1"
                  style={{ color: "var(--typeColor)" }}
                ></i>
                <span>{addressdata?.email}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CurrentAddress;
